export const createHeadline = ({
  headlineTitle,
  appointmentTypeName,
}) => (!headlineTitle || !appointmentTypeName ? 'All Things Baby' : `${headlineTitle}: ${appointmentTypeName}`);
